import { Organization } from './organization';
import {
  type CampaignDataObject,
  type PriceDataObject,
  type PriceGroupDataObject,
  type PriceInterval,
} from './service';

export type CampaignPaymentMethod = 'braintree' | 'stripe';

export type Price = {
  stripeId: string;
  amount: string;
};

export type PriceGroup = Partial<Record<PriceInterval, Price[]>>;

const createPrice = (priceObject: PriceDataObject): Price => ({
  stripeId: priceObject.stripe_id,
  amount: priceObject.amount,
});

const createGroupPrices = (priceGroup: PriceGroupDataObject): PriceGroup => {
  const data: PriceGroup = {};
  for (const [key, value] of Object.entries(priceGroup)) {
    data[key] = [];
    for (const priceData of value) {
      data[key].push(createPrice(priceData));
    }
  }

  return data;
};

export class Campaign {
  id: string;
  name: string;
  paymentMethods: CampaignPaymentMethod[];
  organization: Organization;
  prices: PriceGroup;

  constructor(data: CampaignDataObject) {
    this.id = data.id;
    this.name = data.name;
    this.paymentMethods = data.payment_methods;
    this.organization = new Organization(data.organization);
    this.prices = createGroupPrices(data.prices);
  }
}
